/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Modal } from '@material-ui/core';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        position: 'relative',
    },
    modalContainer: {
        backgroundColor: theme.palette.white,
        width: '270px',
        height: '200px',
        position: 'relative',
        overflow: 'auto',
    },
    modalXs: {
        minHeight: '250px',
        maxHeight: '90vh',
        width: '270px',
        height: 'auto',
    },
    modalSm: {
        minWidth: '280px',
        maxHeight: '250px',
        width: '26%',
        height: '80vh',
    },
    modalMd: {
        width: '55%',
        height: '80vh',
    },
    modalLg: {
        width: '90%',
        height: 'calc(100% - 100px)',
    },
    headingText: {
        color: theme.palette.cta1,
        textTransform: 'uppercase',
        fontSize: '1em',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0 10px',
        padding: '0 4px',
        fontWeight: '700',
        borderBottom: `3px solid ${theme.palette.cms?.primary || theme?.palette?.common?.black}`,
        textAlign: 'center',
        position: 'sticky',
        top: '0',
        background: theme.palette.cms?.white || '#ffffff',
        zIndex: 2,
    },
    alignTextLeft: {
        textAlign: 'left',
    },
    description: {
        background: theme.palette.white,
        overflowY: 'auto',
        padding: '5px 10px 0',
        '& a': {
            color: theme.palette.cta1,
            textDecoration: 'none',
        },
        '& h2': {
            fontSize: '0.9em',
            color: theme.palette.cta1,
            margin: '20px 0 7px',
        },
        '& img': {
            width: 'auto',
        },
        '& p': {
            marginTop: '0',
        },
    },
    right: {
        right: '0px',
        position: 'absolute',
        fontSize: '20px',
        fontWeight: '100',
        cursor: 'pointer',
    },

});

const ModalWrapper = (props) => {
    const {
        modalTitle, modalContent, classes, onCloseModal, isOpen, btnClose, alignItem, modalSize, customStyle,
    } = props;
    let classTitle = classes.headingText;
    if (alignItem === 'left') {
        classTitle = `${classes.headingText} ${classes.alignTextLeft}`;
    }
    const modalContainerSize = () => {
        switch (modalSize) {
            case 'xs':
                return `${classes.modalContainer} ${classes.modalXs}`;
            case 'sm':
                return `${classes.modalContainer} ${classes.modalSm}`;
            case 'md':
                return `${classes.modalContainer} ${classes.modalMd}`;
            case 'lg':
                return `${classes.modalContainer} ${classes.modalLg}`;
            case 'custom':
                return `${classes.modalContainer} ${customStyle}`;
            default:
                return classes.modalContainer;
        }
    };
    return (
        <div>
            <Modal
                id="modalWrapper"
                open={isOpen}
                onClose={onCloseModal}
                className={classes.modal}
            >
                <div className={modalContainerSize()}>
                    <h1 id="h1-title" data-testid="h1-title" className={classTitle}>
                        {modalTitle}
                        { btnClose && (<span id="modalClose" data-testid="modalClose" className={classes.right} onClick={() => onCloseModal()} onKeyDown={() => { }} role="button" tabIndex={-1}>X</span>)}
                    </h1>
                    <div id="modal-content" data-testid="modal-content" className={classes.description}>
                        {modalContent}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

ModalWrapper.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalTitle: PropTypes.string.isRequired,
    modalContent: PropTypes.element.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    btnClose: PropTypes.bool,
    alignItem: PropTypes.string,
    modalSize: PropTypes.string,
    customStyle: PropTypes.string,
};

ModalWrapper.defaultProps = {
    btnClose: true,
    alignItem: 'center',
    modalSize: 'small',
    customStyle: '',
};

export default withStyles(styles)(ModalWrapper);
